import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GalleryPageRoutingModule } from './gallery-page-routing.module';
import { GallryPageComponent } from './gallry-page/gallry-page.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { LoaderService, CommonService, SortAlV1Service } from 'abs-ngx-library/src/lib/core';
import { LoyaltyCardModule } from 'abs-ngx-library/src/lib/loyalty-card';
import { SortByAlV1Module } from 'abs-ngx-library/src/lib/sort';
import { DealsHubModule } from 'abs-ngx-library/src/lib/deals-hub';
import { GridService } from 'src/app/shared/services/grid.service';
import { PaginationService } from 'src/app/shared/services/pagination.service';
import { OfferCardGridComponent } from './offer-card-grid/offer-card-grid.component';
import { LeftNavigationComponent } from './left-navigation/left-navigation.component';
import { DealsHubComponent } from './deals-hub/deals-hub.component';
import { AutoclipMessagesComponent } from './autoclip-messages/autoclip-messages.component';
import { BannerUnitModule } from 'abs-ngx-library/src/lib/banner-unit';
import { ForuPlusLogoModule } from 'abs-ngx-library/src/lib/foru-plus-logo';


@NgModule({
  declarations: [
    GallryPageComponent,
    OfferCardGridComponent,
    LeftNavigationComponent,
    DealsHubComponent,
    AutoclipMessagesComponent
  ],
  imports: [
    CommonModule,
    GalleryPageRoutingModule,
    SharedModule,
    LoyaltyCardModule,
    SortByAlV1Module,
    DealsHubModule,
    BannerUnitModule,
    ForuPlusLogoModule
  ],
  providers: [
    LoaderService,
    CommonService,
    SortAlV1Service,
    GridService,
    PaginationService
  ],
  exports: [
    LeftNavigationComponent
  ]
})
export class GalleryPageModule { }
